import React, { useEffect, useState, lazy } from 'react';
import { FloatingCTA } from './components/FloatingCTA';
import { MobilePopup } from './components/MobilePopup';
import { GoogleTag } from './components/GoogleTag';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  const [showMobilePopup, setShowMobilePopup] = useState(false);
  useEffect(() => {
    // Set the document title
    document.title = 'Why Your $190 "Supportive"';
  }, []);
  useEffect(() => {
    // Check if it's a mobile device using window width
    const isMobile = window.innerWidth < 1024; // 1024px is the lg breakpoint in Tailwind
    // Show popup on mobile devices after a short delay
    if (isMobile) {
      const timer = setTimeout(() => {
        setShowMobilePopup(true);
      }, 1500); // 1.5 second delay
      return () => clearTimeout(timer);
    }
  }, []);
  return <div className="w-full bg-white font-sans" data-id="element-0">
      {/* Google Tag Manager implementation */}
      <GoogleTag data-id="element-1" />
      {/* Meta Pixel implementation */}
      <MetaPixel data-id="element-2" />
      {showMobilePopup && <MobilePopup onClose={() => setShowMobilePopup(false)} data-id="element-3" />}
      <TopBanner data-id="element-4" />
      <Header data-id="element-5" />
      <div className="flex justify-center" data-id="element-6">
        <main className="max-w-3xl px-4 pb-12 lg:mr-80" data-id="element-7">
          <HeroSection data-id="element-8" />
          <ProblemSection data-id="element-9" />
          <ProductSection data-id="element-10" />
          <TransformationSection data-id="element-11" />
          <ScienceSection data-id="element-12" />
          <TestimonialsSection data-id="element-13" />
          <ChoiceSection data-id="element-14" />
          <CTASection data-id="element-15" />
        </main>
        <FloatingCTA data-id="element-16" />
      </div>
      <footer className="text-center text-base text-gray-400 py-4 border-t" data-id="element-17">
        <p data-id="element-18">© 2024 Nice Shoes. All rights reserved.</p>
      </footer>
      <div className="bg-gray-100 py-2 text-center text-xs text-gray-600 font-bold" data-id="element-19">
        THIS IS AN ADVERTISEMENT AND NOT AN ACTUAL NEWS ARTICLE, BLOG, OR
        CONSUMER PROTECTION UPDATE
      </div>
    </div>;
}
function TopBanner() {
  return <div className="bg-gray-100 py-2 px-4 flex items-center justify-center" data-id="element-20">
      <span className="font-bold text-lg text-gray-800 mr-2" data-id="element-21">
        Orthopedic Central
      </span>
      <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2TBECoNGhL1XhTtsxrh8eV/Sora_Task_01_Image_1.webp" alt="Orthopedic Central Logo" className="h-7" data-id="element-22" />
    </div>;
}
function Header() {
  return <header className="bg-white py-4 px-4 border-b" data-id="element-23">
      <h1 className="text-2xl font-bold text-center text-gray-800" data-id="element-24"></h1>
    </header>;
}
function HeroSection() {
  return <section className="py-8" data-id="element-25">
      <h2 className="text-4xl font-bold mb-4" data-id="element-26">
        Why Your $190 "Supportive" Shoes Are Actually Making Your Foot Pain
        WORSE (And How This "Barefoot" Discovery is Healing Thousands)
      </h2>
      <p className="text-xl text-gray-600 italic mb-6" data-id="element-27">
        By Sarah Chen, Former Chronic Pain Sufferer
      </p>
      <div className="bg-purple-100 rounded-lg p-6 mb-8" data-id="element-28">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jH8ho5HETabwWub6jaKGqY/Untitled-1.png" alt="A Barefoot Discovery - Beige barefoot shoe with orange flexible sole and Nice Shoes logo" className="w-full h-auto object-cover rounded-lg mb-4" data-id="element-29" />
        <p className="text-xl text-gray-700" data-id="element-30">
          Revolutionary "barefoot" technology is helping thousands of Americans
          overcome chronic foot, knee, and back pain without expensive orthotics
          or surgeries.
        </p>
      </div>
      <p className="text-xl mb-4" data-id="element-31">
        I'll never forget the moment my podiatrist handed me those custom
        orthotics.
      </p>
      <p className="text-xl mb-4" data-id="element-32">
        "These will fix everything," he said confidently. "$450, but Sarah,
        you'll thank me in six months."
      </p>
      <p className="text-xl mb-4" data-id="element-33">That was three years ago.</p>
      <p className="text-xl mb-4" data-id="element-34">
        Three years of morning agony stepping out of bed. Three years of
        avoiding hikes with my family. Three years of watching my life shrink
        because of stabbing foot pain, aching knees, and constant lower back
        tension.
      </p>
      <p className="text-xl mb-4" data-id="element-35">The orthotics? They made everything worse.</p>
      <p className="text-xl mb-4" data-id="element-36">
        I'd shuffle to the kitchen each morning, wincing with every step. By
        afternoon, my lower back would be screaming. Evening walks became
        impossible. I started avoiding social gatherings where I'd have to
        stand.
      </p>
      <p className="text-xl mb-4" data-id="element-37">
        But here's what shocked me even more than my wasted money: My podiatrist
        was completely wrong about what was causing my pain.
      </p>
    </section>;
}
function ProblemSection() {
  return <section className="py-8 border-t border-gray-200" data-id="element-38">
      <h2 className="text-3xl font-bold mb-4" data-id="element-39">The Billion-Dollar Secret</h2>
      <div className="flex flex-col md:flex-row gap-6 items-center mb-6" data-id="element-40">
        <div className="md:w-1/2" data-id="element-41">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/voviudxhcubSbCwKvibQ8G/Sora_Task_01_Image_0.webp" alt="The Barefoot Classic - Light blue barefoot shoe with 45% OFF TODAY promotion" className="w-full rounded-lg" data-id="element-42" />
        </div>
        <div className="md:w-1/2" data-id="element-43">
          <p className="text-xl mb-4" data-id="element-44">
            What if everything you've been told about "supportive" footwear is
            wrong? The shoe industry hopes you never discover this truth: your
            "supportive" shoes are actually making your feet weaker.
          </p>
          <p className="text-xl" data-id="element-45">
            Harvard research confirms modern shoes weaken your feet over time,
            just like a cast weakens an arm. This leads to a domino effect of
            issues – lazy arches, crowded toes, hard heel strikes – throwing
            your body out of alignment and causing pain.
          </p>
        </div>
      </div>
    </section>;
}
function DiscoverySection() {
  return <section className="py-8 border-t border-gray-200" data-id="element-46">
      <h2 className="text-3xl font-bold mb-4" data-id="element-47">My "Aha" Moment</h2>
      <p className="text-xl mb-4" data-id="element-48">
        I was at rock bottom. Then, a desperate act, inspired by revolutionary
        science, led me to a simple, radical discovery that changed everything.
      </p>
      <p className="text-xl mb-4" data-id="element-49">
        I decided to try walking barefoot. My husband thought I was crazy, but I
        was desperate. I started slowly. By week two, I felt more stable, more
        balanced. By week three, something incredible happened: I woke up
        without morning foot pain for the first time in years. I actually cried.
      </p>
      <p className="text-xl mb-4" data-id="element-50">
        But the real world isn't built for bare feet. I needed protection
        without going back to foot-weakening traditional shoes.
      </p>
    </section>;
}
function ProductSection() {
  return <section className="py-8 border-t border-gray-200" data-id="element-51">
      <h2 className="text-3xl font-bold mb-4" data-id="element-52">
        Nice Shoes: The "Impossible" Shoe
      </h2>
      <div className="flex flex-col md:flex-row gap-6 items-center mb-6" data-id="element-53">
        <div className="md:w-1/2" data-id="element-54">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wivj5JdW8HyHUrp1Aj21hF/Image_1000x1000_%281%29.webp" alt="Nice Shoes barefoot shoes" className="w-full rounded-lg" data-id="element-55" />
        </div>
        <div className="md:w-1/2" data-id="element-56">
          <p className="text-xl mb-4" data-id="element-57">
            I needed a miracle. I searched endlessly until I found a small
            company that had cracked the code. They created the "impossible"
            shoe: one that protects your feet but strengthens them like going
            barefoot.
          </p>
          <p className="text-xl mb-4" data-id="element-58">
            Nice Shoes isn't just "minimalist"; it's rehabilitative footwear. It
            activates and rebuilds your natural foot strength, step by powerful
            step.
          </p>
        </div>
      </div>
      <div className="bg-gray-50 p-6 rounded-lg" data-id="element-59">
        <h3 className="text-2xl font-bold mb-4" data-id="element-60">
          Here's what makes them revolutionary:
        </h3>
        <ul className="text-xl space-y-4" data-id="element-61">
          <li className="flex items-start" data-id="element-62">
            <span className="font-bold mr-2" data-id="element-63">Zero Drop Design:</span> 🦶 Your
            heel and toes sit at the same level, promoting natural alignment.
          </li>
          <li className="flex items-start" data-id="element-64">
            <span className="font-bold mr-2" data-id="element-65">Wide Toe Box:</span> 👣 Your toes
            can spread naturally, restoring balance and engaging foot muscles.
          </li>
          <li className="flex items-start" data-id="element-66">
            <span className="font-bold mr-2" data-id="element-67">Flexible Sole:</span> 🤸 Bends and
            moves with your foot, letting muscles work and strengthen.
          </li>
          <li className="flex items-start" data-id="element-68">
            <span className="font-bold mr-2" data-id="element-69">Natural Movement Technology:</span>{' '}
            ✨ Engineered to let your feet engage, adapt, and grow stronger,
            just as nature intended.
          </li>
        </ul>
      </div>
    </section>;
}
function TransformationSection() {
  return <section className="py-8 border-t border-gray-200" data-id="element-70">
      <h2 className="text-3xl font-bold mb-4" data-id="element-71">My Life Transformed</h2>
      <p className="text-xl mb-4" data-id="element-72">
        The first day in DRYSHOES, my feet felt connected to the ground. Within
        weeks, my morning foot pain completely disappeared. Soon after, I hiked
        5 miles with my family for the first time in years – no pain, no
        hobbling. I got my life back.
      </p>
      <p className="text-xl mb-4" data-id="element-73">
        A month later, I threw away my orthotics for good. Today, I hike 10+
        miles regularly and feel stronger at 47 than I did at 27.
      </p>
      <div className="flex justify-center my-6" data-id="element-74">
        <img src="https://images.unsplash.com/photo-1551632811-561732d1e306?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="Happy hiker in nature" className="w-3/4 rounded-lg" data-id="element-75" />
      </div>
    </section>;
}
function ScienceSection() {
  return <section className="py-8 border-t border-gray-200" data-id="element-76">
      <h2 className="text-3xl font-bold mb-4" data-id="element-77">The Science Doesn't Lie</h2>
      <p className="text-xl mb-4" data-id="element-78">
        The old paradigm of "support" is crumbling. Science confirms what your
        body knows:
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-6" data-id="element-79">
        <div className="bg-gray-50 p-4 rounded-lg" data-id="element-80">
          <p className="text-2xl font-bold text-center" data-id="element-81">9 out of 10</p>
          <p className="text-xl text-center" data-id="element-82">
            people found relief from plantar fasciitis in weeks
          </p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg" data-id="element-83">
          <p className="text-2xl font-bold text-center" data-id="element-84">57%</p>
          <p className="text-xl text-center" data-id="element-85">
            improvement in foot strength in just 6 months
          </p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg" data-id="element-86">
          <p className="text-2xl font-bold text-center" data-id="element-87">42%</p>
          <p className="text-xl text-center" data-id="element-88">fewer injuries among runners</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg" data-id="element-89">
          <p className="text-2xl font-bold text-center" data-id="element-90">Significant</p>
          <p className="text-xl text-center" data-id="element-91">
            improvements in balance, posture, and mobility
          </p>
        </div>
      </div>
      <p className="text-xl text-center font-bold" data-id="element-92">
        The evidence is overwhelming: your feet were designed to be strong.
      </p>
    </section>;
}
function TestimonialsSection() {
  return <section className="py-8 border-t border-gray-200" data-id="element-93">
      <h2 className="text-3xl font-bold mb-6" data-id="element-94">Real Results</h2>
      <div className="space-y-4" data-id="element-95">
        <div className="bg-gray-50 p-4 rounded-lg" data-id="element-96">
          <p className="text-xl italic" data-id="element-97">
            "My plantar fasciitis disappeared in 6 weeks."
          </p>
          <p className="text-xl font-bold mt-2" data-id="element-98">– Mike R., Portland</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg" data-id="element-99">
          <p className="text-xl italic" data-id="element-100">"Chronic back pain 90% gone."</p>
          <p className="text-xl font-bold mt-2" data-id="element-101">– Jennifer L., Seattle</p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg" data-id="element-102">
          <p className="text-xl italic" data-id="element-103">
            "Cancelled knee replacement consultation. Best purchase ever."
          </p>
          <p className="text-xl font-bold mt-2" data-id="element-104">– Lisa M., Denver</p>
        </div>
      </div>
    </section>;
}
function ChoiceSection() {
  return <section className="py-8 border-t border-gray-200" data-id="element-105">
      <h2 className="text-3xl font-bold mb-4" data-id="element-106">Your Choice</h2>
      <div className="space-y-6" data-id="element-107">
        <div className="p-4 border rounded-lg" data-id="element-108">
          <p className="text-xl font-bold mb-2" data-id="element-109">Choice #1:</p>
          <p className="text-xl" data-id="element-110">
            Keep weakening your feet with "supportive" shoes, masking symptoms
            with orthotics, and accepting pain as "part of getting older."
          </p>
        </div>
        <div className="p-4 border-2 border-yellow-400 rounded-lg bg-yellow-50" data-id="element-111">
          <p className="text-xl font-bold mb-2" data-id="element-112">Choice #2:</p>
          <p className="text-xl" data-id="element-113">
            Try the natural approach. Let your feet regain their strength,
            freedom, and ability to fully engage with life.
          </p>
        </div>
      </div>
    </section>;
}
function CTASection() {
  return <section className="py-10" data-id="element-114">
      <div className="bg-purple-600 text-white p-8 rounded-lg text-center" data-id="element-115">
        <h2 className="text-4xl font-bold mb-4" data-id="element-116">
          Ready to unlock your body's full potential?
        </h2>
        <a href="https://www.theniceshoes.store/" className="inline-block bg-yellow-400 hover:bg-yellow-500 text-black font-bold py-3 px-8 rounded-full text-2xl my-6 transition-all cursor-pointer" data-id="element-117">
          BUY NOW— 45% OFF
        </a>
        <p className="text-xl mt-4" data-id="element-118">
          Your journey back to effortless, pain-free movement starts with a
          single step. Make it count.
        </p>
      </div>
    </section>;
}